module.exports = __webpack_public_path__ + "38465cc60db58d68dc019db2662fd02f.png";